import React from "react";
import { useFormBuilderEditorContext } from "../formBuilderEditorContext";
import "./formBuilderPanel.scss";
import { FormBuilderPanelItemView } from "./views/item/FormBuilderPanelItemView";
import { FormBuilderPanelRowView } from "./views/row/FormBuilderPanelRowView";
import { FormBuilderPanelFormView } from "./views/form/FormBuilderPanelFormView";
import { useFormBuilderItemMetadataMap } from "../hooks/itemMetadataMap/useFormBuilderItemMetadataMap";
import { getFormBuilderItemKindKey, TFormBuilderItem } from "../model/item/formBuilderItem";
import { IFormBuilderRow } from "../model/formBuilderRow";

export function FormBuilderPanel() {
  const { panelRef, formBuilderController } = useFormBuilderEditorContext();

  const metadataMap = useFormBuilderItemMetadataMap();

  const selectedEntity = formBuilderController.selectedEntity;

  const selectedRow = selectedEntity?.type === "row"
    ? formBuilderController.entityMap.get(selectedEntity.key) as IFormBuilderRow
    : null;

  const selectedItem = selectedEntity?.type === "item"
    ? formBuilderController.entityMap.get(selectedEntity.key) as TFormBuilderItem
    : null;

  const selectedItemRow = selectedEntity?.type === "item"
    ? formBuilderController.entityMap.get(selectedEntity.rowKey) as IFormBuilderRow
    : null;
  
  const selectedItemMetadata = selectedItem != null ?
    metadataMap.get(getFormBuilderItemKindKey(selectedItem.data.type, selectedItem.data.role)) : null;

  function renderView() {
    if (selectedItem != null && selectedItemRow != null && selectedItemMetadata != null) {
      return <FormBuilderPanelItemView row={selectedItemRow} item={selectedItem} metadata={selectedItemMetadata} />;
    } else if (selectedRow != null) {
      return <FormBuilderPanelRowView row={selectedRow} />;
    } else {
      return <FormBuilderPanelFormView />;
    }
  }

  return (
    <div
      ref={panelRef}
      className="form-builder-panel"
    >
      {renderView()}
    </div>
  );
}